import { useEffect, useState } from "react";
import { set } from "react-hook-form";
import { Navigate } from "react-router-dom";

const Protected = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const token = localStorage.getItem("auth_token")
       useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (!token) {
         window.location.href="/login"
        } 
      }, [window.location.pathname]);
    
    return children;
   
};
export default Protected;